module.exports = __webpack_public_path__ + "img/play_color.a5196fe4.svg";